<template>
  <el-dialog title="修改提货日期" class="global-dialog" :visible.sync="showDlg" width="400px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form2" label-width="100px">
        <el-row>

          <el-col :span="24">
            <el-form-item prop="pickupDate" label="提货日期">
              <el-date-picker v-model="formData.pickupDate" type="date" placeholder="请选择提货日期" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>

  </el-dialog>
</template>
<script>

export default {
  props: {

    showDlg: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    },
    pickupDate: {
      type: String,
      default: ''
    }
  },

  data () {
    return {

      formData: {
        pickupDate: '',
        orderId: ''

      },
      rules: {
        pickupDate: [
          {
            required: false,
            message: '请选择提货日期',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false
    }
  },
  created() {
    this.formData.pickupDate = this.pickupDate || ''
    console.log(' this.formData: ', this.formData)
  },

  methods: {

    submitDlg () {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        this.loading = true
        const url = this.$apis.yxcOrderManage.updateYxcPriceOrderDate
        this.$axios.post(url, { ...this.formData, orderId: this.orderId }).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    },
    handleClose () {
      this.$emit('update:showDlg', false)
    }
  }
}
</script>

<style scoped lang="scss">
.el-date-editor {
  width: 100%;
}
</style>
